// utils/distance.ts
const toRad = (v: number) => (v * Math.PI) / 180;

/** Calcola la distanza in km tra due coordinate (formula Haversine) */
export function haversineKm(
  lat1?: number | string,
  lon1?: number | string,
  lat2?: number | string,
  lon2?: number | string
): number {
  const R = 6371; // raggio terrestre medio in km
  if (
    lat1 == null ||
    lon1 == null ||
    lat2 == null ||
    lon2 == null ||
    isNaN(Number(lat1)) ||
    isNaN(Number(lon1)) ||
    isNaN(Number(lat2)) ||
    isNaN(Number(lon2))
  )
    return NaN;

  const dLat = toRad(Number(lat2) - Number(lat1));
  const dLon = toRad(Number(lon2) - Number(lon1));
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(Number(lat1))) *
      Math.cos(toRad(Number(lat2))) *
      Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

/** Restituisce una stringa leggibile: metri se <1km, altrimenti 1 decimale */
export function formatDistance(km?: number): string {
  if (!km || !Number.isFinite(km)) return "";
  if (km < 1) return `${Math.round(km * 1000)} m`;
  return `${km.toFixed(1)} km`;
}
